// path/to/tipoPixState.ts
import { atom } from "recoil";

export const tipoPixState = atom<string>({
  key: "tipoPixState",
  default: "CHAVE",
});
